import React from 'react';

export const CalculatorRow = ({children, visibleClass}) => {
  return (
    <div className={`calculator-row ${visibleClass}`}>
      <div className="row">
        {children}
      </div>
    </div>
  );
};
